import { useQuery } from "@tanstack/react-query";

import { EmdrSessionsAPI } from "../infrastructure/api/EmdrSessions.api";
import { isIndividualSession } from "../domain/emdrSets";

/** The session a board runs for, and whether its sets can be rated. */
export function useBoardSession(sessionId: string) {
    const query = useQuery({
        queryKey: ["emdr-board-session", sessionId],
        queryFn: async () => (await EmdrSessionsAPI.get(sessionId)).data,
        retry: false,
    });
    const session = query.data;
    const individual = session ? isIndividualSession(session) : false;
    return { session, individual, loading: query.isLoading, failed: query.isError };
}
